import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "geolocation"
const GeolocationIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M5.00159637,14.0050314 C3.96269709,14.0050314 3.61277575,12.6171023 4.52749654,12.1245603 L17.5274965,5.1245603 C18.4009599,4.6542339 19.3523939,5.6056679 18.8820675,6.47913122 L11.8820675,19.4791312 C11.3895255,20.393852 10.0015964,20.0439307 10.0015964,19.0050314 L10.0015965,14.0050316 L5.00159637,14.0050314 Z" />
        </svg>
      }
    </span>
  )
}
export default GeolocationIcon
